import { Check, Close } from "@mui/icons-material";
import { Alert, Box, IconButton } from "@mui/material";

type ChatConfirmBoxProps = {
    title: string;
    icon?: boolean | undefined;
    onClose: () => void;
    onConfirm: () => void;
}

const ChatConfirmBox: React.FC<ChatConfirmBoxProps> = ({ title, icon, onClose, onConfirm }) => {
    return (
        <Box className="chatyme-alert-box">
            <Alert icon={icon} variant="outlined" severity="warning" className="chatyme-text-wrap"
                sx={{ borderRadius: '0', '& .MuiAlert-action': { paddingTop: '0' } }}
                action={
                    <>
                        <IconButton
                            onClick={onClose}
                            size="small"
                            color="error"
                        >
                            <Close />
                        </IconButton>
                        <IconButton
                            onClick={onConfirm}
                            size="small"
                            color="success"
                        >
                            <Check />
                        </IconButton>
                    </>
                }>
                {title}
            </Alert>
        </Box>
    )
}

export default ChatConfirmBox;